import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  const problems = ['No es que eyacules rápido', 'No es que pierdas la erección', 'No es que "no sirvas"'];
  const failedTactics = ['más esfuerzo', 'más presión', 'más "técnicas rápidas"'];
  return <section className="relative w-full bg-[#0a0a0a] py-10 md:py-14 overflow-hidden" data-id="element-354">
      <div className="absolute inset-0 z-0" data-id="element-355">
        <div className="absolute top-1/2 -left-1/4 w-[500px] h-[500px] rounded-full bg-red-800/15 blur-[120px]" data-id="element-356" />
      </div>

      <div className="absolute top-0 left-0 right-0 h-16 bg-gradient-to-b from-black to-transparent z-10" data-id="element-357" />
      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-black to-transparent z-10" data-id="element-358" />

      <div className="relative z-20 max-w-3xl mx-auto px-6" data-id="element-359">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-360">
          <div className="flex items-center gap-3 mb-6" data-id="element-361">
            <div className="w-12 h-px bg-red-600" data-id="element-362" />
            <span className="text-red-500 text-xs uppercase tracking-[0.3em] font-bold" data-id="element-363">
              El Diagnóstico
            </span>
          </div>

          <h2 className="font-display text-4xl md:text-5xl uppercase mb-8 text-white drop-shadow-[0_0_25px_rgba(220,38,38,0.3)]" data-id="element-364">
            <span className="text-red-500 drop-shadow-[0_0_15px_rgba(220,38,38,0.8)]" data-id="element-365">
              ❌
            </span>{' '}
            El problema no es...
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-10" data-id="element-366">
            {problems.map((problem, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.08,
            duration: 0.4
          }} className="bg-black/50 backdrop-blur-sm border border-red-900/30 rounded-lg px-4 py-4 flex items-center gap-3" data-id="element-367">
                <span className="text-red-500 text-xl flex-shrink-0" data-id="element-368">❌</span>
                <span className="text-sm md:text-base text-gray-300" data-id="element-369">
                  {problem}
                </span>
              </motion.div>)}
          </div>

          <div className="relative bg-gradient-to-b from-[#0a0a0a] to-black border border-red-900/50 p-6 md:p-8 rounded-lg shadow-[0_0_40px_rgba(220,38,38,0.1)] overflow-hidden mb-10" data-id="element-370">
            <span className="absolute top-0 left-0 w-6 h-6 border-t-2 border-l-2 border-red-600" data-id="element-371" />
            <span className="absolute top-0 right-0 w-6 h-6 border-t-2 border-r-2 border-red-600" data-id="element-372" />
            <span className="absolute bottom-0 left-0 w-6 h-6 border-b-2 border-l-2 border-red-600" data-id="element-373" />
            <span className="absolute bottom-0 right-0 w-6 h-6 border-b-2 border-r-2 border-red-600" data-id="element-374" />

            <p className="text-base md:text-lg font-semibold mb-3 text-gray-400 uppercase tracking-wider" data-id="element-375">
              El problema real:
            </p>
            <p className="text-xl md:text-2xl flex items-start gap-3 leading-snug" data-id="element-376">
              <span className="text-red-500 text-2xl mt-0.5" data-id="element-377">👉</span>
              <span className="font-bold text-yellow-400 drop-shadow-[0_0_12px_rgba(251,191,36,0.4)]" data-id="element-378">
                Tu mente, tu cuerpo y tus hábitos están desincronizados.
              </span>
            </p>
          </div>

          <div className="bg-black/40 border border-red-900/30 rounded-lg p-6" data-id="element-379">
            <p className="text-base md:text-lg text-gray-300 mb-4" data-id="element-380">
              Y mientras lo intentes arreglar con:
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-5" data-id="element-381">
              {failedTactics.map((tactic, index) => <p key={index} className="text-sm md:text-base text-gray-400 flex items-center gap-2" data-id="element-382">
                  <span className="text-red-500/60" data-id="element-383">✗</span> {tactic}
                </p>)}
            </div>
            <p className="text-lg md:text-xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-red-400 to-red-600 drop-shadow-[0_0_15px_rgba(220,38,38,0.4)] flex items-center gap-3" data-id="element-384">
              <span className="text-red-500 text-2xl" data-id="element-385">👉</span>
              Vas a seguir en el mismo ciclo.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}